define.alias("shared/components/shared/social/refresh-profile", "calendar/components/shared/social/refresh-profile");